import { Progress } from "@ark-ui/react";
import {
  AromaLoaderVariantProps,
  aromaLoader,
} from "@zenchef/styled-system/recipes";
import React, { ElementRef, forwardRef } from "react";

export type LoaderProps = AromaLoaderVariantProps &
  Progress.RootProps &
  React.HTMLAttributes<HTMLDivElement> & {
    testId?: string;
    description?: string;
  };

/**
 * Loader
 * @returns Styled horizontal loader indicator implemented with arkui.
 */
const Loader = forwardRef<ElementRef<"div">, LoaderProps>(
  ({ testId, description, ...propsWithVariants }, ref) => {
    const [variants, props] = aromaLoader.splitVariantProps(propsWithVariants);
    const classes = aromaLoader(variants);

    return (
      <Progress.Root
        className={classes.root}
        ref={ref}
        data-testid={testId}
        value={100}
        {...props}
      >
        <Progress.Track className={classes.track}>
          <Progress.Range className={classes.range} />
        </Progress.Track>
        {description && (
          <Progress.Label className={classes.label}>
            {description}
          </Progress.Label>
        )}
      </Progress.Root>
    );
  },
);

export default Loader;
